import { useAuthStore } from '@/store/auth.store'

const NAME_TO_ISO: Array<[RegExp, string]> = [
  [/RIYAL|\bSAR\b/, 'SAR'],
  [/DIRHAM|\bAED\b/, 'AED'],
  [/EURO|\bEUR\b/, 'EUR'],
  [/DOLLAR|\bUSD\b/, 'USD'],
  [/POUND|\bGBP\b/, 'GBP'],
  [/RUPEE|\bPKR\b/, 'PKR'],
]

/** Map a lookup name or stored value to an ISO 4217 currency code. */
export function toIsoCurrencyCode(value?: string | null): string {
  const raw = (value ?? '').trim()
  if (!raw) return 'SAR'
  if (/^[A-Za-z]{3}$/.test(raw)) return raw.toUpperCase()

  const upper = raw.toUpperCase()
  for (const [pattern, iso] of NAME_TO_ISO) {
    if (pattern.test(upper)) return iso
  }
  return 'SAR'
}

/** Currency of the currently selected branch (ISO code). */
export function getBranchCurrency(): string {
  return toIsoCurrencyCode(useAuthStore.getState().user?.selectedBranch?.currency)
}

const CURRENCY_WORDS: Record<string, { major: string; minor: string }> = {
  SAR: { major: 'Saudi Riyals', minor: 'Halalas' },
  USD: { major: 'US Dollars', minor: 'Cents' },
  EUR: { major: 'Euros', minor: 'Cents' },
  AED: { major: 'UAE Dirhams', minor: 'Fils' },
  GBP: { major: 'Pounds', minor: 'Pence' },
  PKR: { major: 'Rupees', minor: 'Paisa' },
}

export function getBranchCurrencyWords(): { major: string; minor: string } {
  const code = getBranchCurrency()
  return CURRENCY_WORDS[code] || { major: code, minor: 'Cents' }
}

export function mapCurrencyLookup(curr: any): {
  id: number
  currencyId: number
  currencyCode: string
  currencyName: string
} {
  const name = String(
    curr?.lookupNameEn ||
      curr?.currencyName ||
      curr?.name ||
      curr?.lookupNameAr ||
      curr?.currencyCode ||
      curr?.code ||
      ''
  )
  const id = Number(curr?.id || curr?.currencyId || 0)
  return {
    id,
    currencyId: Number(curr?.currencyId || curr?.id || 0),
    currencyCode: toIsoCurrencyCode(curr?.currencyCode || curr?.code || name),
    currencyName: name,
  }
}
